import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory } from 'react-router-dom';
import useDeleteTag from './hooks/useDeleteTag';

const DeleteTagModal = ({ id }: DeleteTagProps) => {
    const history = useHistory();

    const { tag, handleSubmit, isDeleting, deleteError, endpoint } = useDeleteTag(id);

    return (
        <ConfirmModal
            title="Delete tag"
            description={`Are you sure you want to delete the tag '${tag.name}'?`}
            closeModal={() => history.replace(`/${endpoint}`)}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
        />
    );
};

interface DeleteTagProps {
    id: number;
}

export default DeleteTagModal;
